// Legacy open-case OKRs can retain a composite type after switching metrics.
// This scalar metric uses its explicitly configured lower-is-better method.
const getEffectiveCalculationType = (keyResult = {}) => {
    if (
        keyResult.automationConfig?.sourceType === 'syncro_operations' &&
        keyResult.automationConfig?.metricKey === 'openTechnicalCaseCount' &&
        keyResult.scoringMethod === 'lower_is_better' &&
        keyResult.calculationType === 'composite_threshold'
    ) return 'manual_value';
    return keyResult.calculationType || 'manual_value';
};

module.exports = { getEffectiveCalculationType };
